import { Flex } from '@chakra-ui/react';
import FormDetails from './FormDetails';
import Design from './Design';
import FormFields from './FormFields';
import CustomQueryParameters from './CustomQueryParameters';
import CustomFooter from './CustomFooter';
import LegalConsent from './LegalConsent';
import DistributionLink from './DistributionLink';

const CustomFormBuilderPanel = ({
  isEdit,
  enableLocked = false,
}: {
  isEdit?: boolean;
  enableLocked?: boolean;
}) => {
  return (
    <Flex direction="column" gap={8} w="full">
      <FormDetails enableLocked={enableLocked} />
      {isEdit && <DistributionLink />}
      <Design />
      <FormFields />
      <CustomQueryParameters />
      <CustomFooter />
      <LegalConsent />
    </Flex>
  );
};

export default CustomFormBuilderPanel;
